import React,{ useState } from 'react';
import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { useRouteMatch } from 'react-router-dom'

// Components
import StyledPage from '../components/StyledPage';
import AuthLayoutWrapper from '../components/AuthLayoutWrapper';
import FormErrors, { trowError } from '../components/FormErrors';
import Button from '../components/Button';

import { UPDATE_RECUPERAR_PASSWORD } from '../models/AcreditacionProfile';


interface MatchParams{
    uuid:string
}

export default () => {
    const { params } = useRouteMatch<MatchParams>();

    const [submitError,setSubmitError] = useState<null|string>(null);
    const [submitConfirm,setSubmitConfirm] = useState<null|string>(null);

  
    const { control, register, handleSubmit, getValues, errors, setValue } = useForm({
        defaultValues:(process.env.NODE_ENV==='development')?{
            password:'645321',
            password_repeat:'645321',
        }:{}
    });

    const [ formSubmit, { loading }] = useMutation(UPDATE_RECUPERAR_PASSWORD);

    const onSubmit = async (data:any) => {
        console.log('on Send data:',data);
        try{
            if(data.password!==data.password_repeat)
                throw({message:'Las contraseñas no coinciden'});


            let response= await formSubmit({ 
                variables:{
                    profile_uuid:params.uuid,
                    password:data.password,
                    code:data.code
                },
                context:{
                    clientName: 'LOGIN',
                }
            });


            if(response.errors)
                throw new trowError(response.errors);

            setSubmitConfirm('Se actualizó la contraseña');
            setSubmitError(null)
        }catch(e){
            console.error(e);
            setSubmitError(e);
            window.scrollTo(0,0);
        }
    }    

    return (
        <StyledPage>
            <AuthLayoutWrapper>
                <h1>Reestablecer contraseña</h1>
                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off" >
                    {submitConfirm?<div className="successful-message">{submitConfirm}</div>:null}
                    {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}
                    {submitConfirm?
                        <p><NavLink to='/login'>Regresar a login</NavLink></p>
                        :<>
                            <input type='text' name="code" required placeholder='Código del correo' ref={register} autoComplete="off" /><br />
                            <input type='password' name="password" required placeholder='Nueva contraseña' ref={register} autoComplete="off" />
                            <input type='password' name="password_repeat" required placeholder='Repetir nueva contraseña' ref={register} autoComplete="off" />
                            <Button type='submit' disabled={loading}>Guardar</Button>
                        </>
                    }
                    
                </form>
            </AuthLayoutWrapper>
        </StyledPage>
    )
};